import axios from '../../lib/axios';

export const getConfigUserRolePermissions = async (): Promise<any> => {
  const response = await axios.get<any[]>(
      `/ConfigAccount/GetConfigUserRolePermissions`
  );
  return response.data;
};

export const getConfigUserGroupRoleWithPermissions = async (configUserGroupKey): Promise<any> => {
  const response = await axios.get<any[]>(
      `/ConfigAccount/GetConfigUserGroupRoleWithPermissions?ConfigUserGroupKey=${configUserGroupKey}`
  );
  return response.data;
};

export const getConfigUserGroupRoleWithPermission = async (): Promise<any> => {
  const response = await axios.get<any[]>(
      `/ConfigAccount/GetConfigUserGroupRoleWithPermissions`
  );
  return response.data;
};

export const insertUpdateMenuAndSubMenu = async (data: any): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/BulkInsertUpdateSubMenu`,
    data
  );
  return response.data;
};

export const getIcons = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/IconMaster/GetIconMaster'
  );
  return response?.data;
};

export const getPageGroupsAndPages = async (): Promise<any> => {
  const response = await axios.get<any[]>(
      `/MenuAndSubMenu/GetPageGroupsAndPages`
  );
  return response.data;
};

export const deletePageGroups = async (pageGroupKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageGroups/${pageGroupKey}`
  );
  return response?.data;
};

export const getPageGroupAndPageByKey = async (pageGroupKey): Promise<any> => {
  const response = await axios.get<any[]>(
      `/MenuAndSubMenu/GetPageGroupsAndPages?PageGroupKey=${pageGroupKey}`
  );
  return response.data;
};

export const deletePages = async (pageKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePages/${pageKey}`
  );
  return response?.data;
};

export const deletePageFilters = async (pageFilterKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageFilters/${pageFilterKey}`
  );
  return response?.data;
};

export const deletePageFilterValues = async (pageFilterValueKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageFilterValues/${pageFilterValueKey}`
  );
  return response?.data;
};

export const getUserGroups = async (userEmail): Promise<any> => {
  const response = await axios.get<any[]>(
    `/InvestApp/GetUserGroups/${userEmail}`
  );
  return response?.data;
};

export const UpdateEnableStatus = async (PageGroupKey: string, IsEnabled: boolean, UserKey: string) => {
    const res = await axios.put(`/MenuAndSubMenu/EnableDisablePageGroup?PageGroupKey=${PageGroupKey}&IsEnabled=${IsEnabled}&UserKey=${UserKey}`);
    return res?.data;
}

export const UpdateEnablePageStatus = async (PageKey: string, IsEnabled: boolean, UserKey: string) => {
    const res = await axios.put(`/MenuAndSubMenu/EnableDisablePage?PageKey=${PageKey}&IsEnabled=${IsEnabled}&UserKey=${UserKey}`);
    return res?.data;
}

export const getWebMethodsList = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/WebMethod/GetWebMethodsList'
  );
  return response?.data;
};

export const GetPageGroupsPagesTree = async (userGroupKey): Promise<any> => {
  const response = await axios.get<any>(
    `/MenuAndSubMenu/GetPageGroupsPagesTree?userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const GetPageGroupKey = async (pageGroupKey, userGroupKey): Promise<any> => {
  const response = await axios.get<any>(
    `/MenuAndSubMenu/GetPageGroupsByKey?pageGroupKey=${pageGroupKey}&userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const GetPageByKey = async (pageKey, userGroupKey): Promise<any> => {
  const response = await axios.get<any>(
    `/MenuAndSubMenu/GetPageByKey?pageKey=${pageKey}&userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const insertUpdatePageGroup = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/InsertUpdatePageGroup`,
    data
  );
  return response.data;
};

export const insertUpdatePage = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/InsertUpdatePage`,
    data
  );
  return response.data;
};

export const GetOtherPageGroups = async (userGroupKey): Promise<any> => {
  const response = await axios.get<any>(
    `/MenuAndSubMenu/GetOtherPageGroups?userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const GetOtherPages = async (userGroupKey): Promise<any> => {
  const response = await axios.get<any>(
    `/MenuAndSubMenu/GetOtherPages?userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const PageGroupUserGroupMapping = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/PageGroupUserGroupMapping`,
    data
  );
  return response.data;
};

export const PageGroupPageMapping = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/PageGroupPageMapping`,
    data
  );
  return response.data;
};

export const DeleteUserGroupPageGroupMapping = async (pageGroupKey, userGroupKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeleteUserGroupPageGroupMapping?pageGroupKey=${pageGroupKey}&userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const DeletePageGroupPageMapping = async (pageKey, pageGroupKey, userGroupKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageGroupPageMapping?pageKey=${pageKey}&pageGroupKey=${pageGroupKey}&userGroupKey=${userGroupKey}`
  );
  return response?.data;
};

export const GetPageFilterList = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/PageFilter/GetPageFilterList'
  );
  return response?.data;
};

export const GetPageFilter = async (pageFilterKey): Promise<any> => {
  const response = await axios.get<any>(
    `/PageFilter/GetPageFilter?pageFilterKey=${pageFilterKey}`
  );
  return response?.data;
};

export const InsertUpdatePageFilter = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/PageFilter/InsertUpdatePageFilter`,
    data
  );
  return response.data;
};